import router from '@/router'

export const get = ({ mpDomain, siteId } = router.currentRoute.params) => {
  let tokens = localStorage.getItem('tokens')
  if (!tokens) return null
  tokens = JSON.parse(tokens)
  return tokens[`${mpDomain}-${siteId}`]
}

export const set = (token, { mpDomain, siteId } = router.currentRoute.params) => {
  let tokens = localStorage.getItem('tokens')
  tokens = tokens ? JSON.parse(tokens) : {}
  tokens[`${mpDomain}-${siteId}`] = token
  localStorage.setItem('tokens', JSON.stringify(tokens))
}

export const remove = ({ mpDomain, siteId } = router.currentRoute.params) => {
  let tokens = localStorage.getItem('tokens')
  if (!tokens) return
  tokens = JSON.parse(tokens)
  delete tokens[`${mpDomain}-${siteId}`]
  localStorage.setItem('tokens', JSON.stringify(tokens))
}
